<template>
    <div class="pagnation_box fc">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="total || 1"
            @current-change="pagChange"
            @size-change="pageSizeChange"
        />
        <span v-if="total && totalShow" class="ml16">共{{ total }}条</span>
    </div>
</template>

<script>
/**
 * @example 
		<c-pagination
			:total="kaoshiTotal"
			:page-size="kaoshiPageSize"
			:current-page="kaoshiPage"
			@pageChange="kaoshiPageChange"
		/>

		kaoshiPageChange({page,size}){
			this.kaoshiPage = page;
			if (size) this.kaoshiPageSize = size;
		}

		created(){
			this.kaoshiPage = this.$route.query.page || 1;
			this.kaoshiPage = this.$route.query.p_size || 10;
		}
 */
export default {
    props: {
        /** 总条数 */
        total: Number,
        /** 每页多少条 */
        pageSize: {
            type: Number,
            default: 1,
        },
        /** 当前第几页 */
        currentPage: {
            type: Number,
            default: 1,
        },
        /** 共计多少页 */
        totalPage: Number,
        /** 是开启路由参数替换 */
        is_open_url_params_replace: { type: Boolean, default: true },
        /** 总条数是否显示 */
        totalShow: { type: Boolean, default: true },
    },
    methods: {
        pagChange(page) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: page,
                    p_size: this.pageSize,
                },
            });
            this.$emit("pageChange", { page, size: this.pageSize });
        },
        pageSizeChange(size) {
            console.debug("size", size);
            if (this.is_open_url_params_replace) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.currentPage,
                        p_size: size,
                    },
                });
            }
            this.$emit("pageChange", { page: this.currentPage, size });
        },
    },
};
</script>

<style lang="scss" scoped>
.pagnation_box {
    margin-top: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .number {
        background-color: #fff !important;
    }

    ::v-deep .active {
        background-color: $primary-color !important;
    }
}
</style>
